import { useQuery } from '@apollo/client';
import { log } from '@atlassian/mpac-utils';
var GetOrgId = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "GetOrgID" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "cloudId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, directives: [] }], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketplaceStore" }, arguments: [], directives: [], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orgId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "cloudId" }, value: { kind: "Variable", name: { kind: "Name", value: "cloudId" } } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "optIn" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "to" }, value: { kind: "StringValue", value: "MarketplaceStoreOrgId", block: false } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orgId" }, arguments: [], directives: [] }] } }] } }] } }], loc: { start: 0, end: 148, source: { body: "query GetOrgID($cloudId: String!) {\n  marketplaceStore {\n    orgId(cloudId: $cloudId) @optIn(to: \"MarketplaceStoreOrgId\") {\n      orgId\n    }\n  }\n}\n", name: "GraphQL request", locationOffset: { line: 1, column: 1 } } } };
export const useOrgIdFromCloudId = _ref => {
  var _data$marketplaceStor, _data$marketplaceStor2;
  let {
    cloudId,
    skipQuery
  } = _ref;
  const {
    data,
    loading,
    error
  } = useQuery(GetOrgId, {
    variables: {
      cloudId
    },
    skip: !cloudId || skipQuery,
    onError(err) {
      log.error('GetOrgIdQuery', "Failed to retrieve org id", {
        error: err
      });
    }
  });
  return {
    data: (data === null || data === void 0 ? void 0 : (_data$marketplaceStor = data.marketplaceStore) === null || _data$marketplaceStor === void 0 ? void 0 : (_data$marketplaceStor2 = _data$marketplaceStor.orgId) === null || _data$marketplaceStor2 === void 0 ? void 0 : _data$marketplaceStor2.orgId) || null,
    loading,
    error
  };
};